/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sort_ReverseInputs */



/**
* | output |
* | --- |
* | "Reverse the order" |
*
* @param {Team_Sort_ReverseInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_sort_reverse = /** @type {((inputs?: Team_Sort_ReverseInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sort_ReverseInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Volgorde omdraaien")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inverser l'ordre")
	return /** @type {LocalizedString} */ ("Reverse the order")
});